import Vue from 'vue'

Vue.use(DeviceDetect())

function DeviceDetect() {
  return {
    install: function () {
      Vue.prototype.$device = {
        isMobileDevice() {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        },
        isTouchScreen() {
          return document.createEvent('TouchEvent')
          // try {
          //   return true;
          // } catch (e) {
          //   return false;
          // }
        },
      }
    },
  }
}
